import {useAtom} from 'jotai'

import store from '..'
import {GetMyInfoService} from '../../service/company.service'
import {IUser} from '../../interface/user/user'

export const useUserDispatch = () => {
  const [_, dispatch] = useAtom(store)

  const setUserLoading = (loading: boolean) => {
    dispatch({type: 'USER/SET_LOADING', payload: loading})
  }
  const setUserProfile = (payload: IUser | undefined) => {
    dispatch({type: 'USER/SET_DATA', payload: payload})
  }

  const getUserProfile = async () => {
    dispatch({type: 'USER/SET_IS_SUPER_ADMIN', payload: false})
    const getMyCompanyService = new GetMyInfoService()
    const res = await getMyCompanyService.request()
    const _myCompany = (await localStorage.getItem('myCompany')) as string
    if (res.isSuperAdmin) {
      dispatch({type: 'USER/SET_IS_SUPER_ADMIN', payload: true})
    } else if (!res.isCompanyGroupAdmin && !res.isSuperAdmin) {
      dispatch({type: 'USER/SET_IS_USER', payload: true})
    }
    if (!res.isCompanyGroupAdmin && !res.isSuperAdmin && !_myCompany) {
      dispatch({type: 'USER/SET_USER_COMPANY', payload: res.companies[0]})
      localStorage.setItem('myCompany', JSON.stringify(res.companies[0]))
    } else if (!res.isCompanyGroupAdmin && !res.isSuperAdmin && _myCompany) {
      dispatch({
        type: 'USER/SET_USER_COMPANY',
        payload: JSON.parse(_myCompany),
      })
    } else {
      localStorage.removeItem('myCompany')
      dispatch({type: 'USER/SET_USER_COMPANY', payload: undefined})
    }
    dispatch({type: 'USER/SET_DATA', payload: res})
  }

  return {
    getUserProfile,
    setUserLoading,
    setUserProfile,
  }
}
